<template>
  <div v-if="dependencies && dependencies.length > 0" class="col-xs-12">
    <p class="text-subtitle-1 text-secondary-1">
      The following milestone(s) have to be completed before this task becomes available in the Progress bar:
    </p>
    <RChip v-for="dependency of dependencies" :key="dependency" style="width: fit-content;">{{ dependency }}</RChip>
  </div>
</template>

<script>
import RChip from '@/ui/RChip'
export default {
  name: 'MilestoneDependencies',
  components: { RChip },
  props: {
    dependencies: {
      type: [Array, null],
      required: true
    }
  }
}
</script>
